import {makeStyles} from "@material-ui/core";

export default function SectionCss() {
    const drawerWidth = 220;
    return makeStyles(theme => ({
        root: {
            
        },
        appBar: {
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {

        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            width: drawerWidth,
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            ...theme.mixins.toolbar,
        },
        arrowClose: {
            justifyContent: 'flex-end',
        },
        content: {
            flexGrow: 1,
        },
        contentShift: {

        },
        mainLogo: {            
            cursor: 'pointer'
        },
        textColors: {
        },
        lb_fornecedor: {
            cursor: 'pointer'
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
        linkText: {
            fontSize:'8pt',
            fontWeight: 'bold',
            textDecoration: 'underline'
        },
        badgeWarning: {
            color: 'white',
            backgroundColor: '#ffa000'
        }
    }));
}